/**
 * Where the in-app updater looks for the latest build.
 *
 * The chartplotter repo is PRIVATE (it has committed signing keys), so the app
 * can't fetch release assets from it — a private release asset needs auth the app
 * can't carry. Instead CI publishes the APK + this manifest to a GitHub Release on
 * the PUBLIC repo ArdentTraining/ardent-chart-packs (the same public repo that
 * already hosts the chart packs).
 *
 * CI reuses ONE release under a fixed tag (`chartplotter-latest`), replacing its
 * assets every build, rather than cutting a new release each time. That gives a
 * stable, auth-free URL that never depends on which release is "latest" in the
 * repo — important because chart packs may one day publish their own releases into
 * the same public repo, and `releases/latest/...` would then be ambiguous.
 *
 * Mirrors PACKS_MANIFEST_URL in chart-sources/packsConfig.ts: one constant, easy
 * to re-point if the release repo ever changes.
 */
const RELEASE_BASE =
  'https://github.com/ArdentTraining/ardent-chart-packs/releases/download/chartplotter-latest';

export const UPDATE_MANIFEST_URL = `${RELEASE_BASE}/update.json`;

/** The APK asset URL CI writes into the manifest (kept here so both sides agree). */
export const UPDATE_APK_URL = `${RELEASE_BASE}/app-debug.apk`;
